import React, { useState } from 'react';
import './App.css';
import TestScreen from './components/Screens/Test';
import StartScreen from './components/Screens/Start';
import Box from '@mui/material/Box';
import logo from './logo.png';

const App = () => {
  const [isTestStarted, setStart] = useState(false);

  const startTest = () => setStart(true);

  return (
    <div className="back">
      <div className="imgLogo">
        <img src={logo} alt="Logo" />
      </div>
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        {isTestStarted ? <TestScreen /> : <StartScreen onStartClick={startTest} />}
      </Box>
    </div>
  );
};

export default App;
